import { Reducer } from 'react';
import { Action as DefaultAction } from 'state/types';

export enum ActionTypes {
  ToggleModal = 'TOGGLE_MODAL',
  Set = 'SET',
  Add = 'ADD',
  Delete = 'DELETE', // TODO: Remove this action as this is not mapped in the reducer
  Update = 'UPDATE',
  Reload = 'RELOAD',
}

export type State = {
  data: {
    [key: number]: {
      id: number;
      name: string;
      start_date: string;
      end_date?: string;
      pinned: boolean;
    }[];
  };
  modal: boolean;
  reload: number;
};

type Payload = {
  [ActionTypes.ToggleModal]: undefined;
  [ActionTypes.Set]: {
    patientId: number;
    data: State['data'][0];
  };
  [ActionTypes.Add]: {
    patientId: number;
    data: State['data'][0][0];
  };
  [ActionTypes.Update]: {
    id: number;
    patientId: number;
  };
  [ActionTypes.Reload]: undefined;
};

export type Action = DefaultAction<Payload>;

export const initialState: State = {
  modal: false,
  reload: 0,
  data: {},
};

export const reducer: Reducer<State, Action> = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case ActionTypes.ToggleModal: {
      return {
        ...state,
        modal: !state.modal,
      };
    }

    case ActionTypes.Set: {
      const { patientId, data } = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          [patientId]: data,
        },
      };
    }

    case ActionTypes.Add: {
      const { patientId, data } = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          [patientId]: [...(state.data[patientId] ? state.data[patientId] : []), data],
        },
      };
    }

    case ActionTypes.Update: {
      const { id, patientId } = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          [patientId]: state.data[patientId].filter((event) => event.id !== id),
        },
      };
    }

    case ActionTypes.Reload: {
      return {
        ...state,
        reload: Date.now(),
      };
    }

    default:
      throw new Error('Unexpected action');
  }
};
